import * as React from 'react'
import { TransferProduct } from '@getgreenline/homi-shared'
import { observer } from 'mobx-react'
import { TransferStore } from '../../TransferStore'

interface Props {
  transferProduct: TransferProduct
  canEditTransfers: boolean
  isEditable: boolean
  transferStore: TransferStore
}

export const AddedTransferBatchTable = observer((props: Props) => {
  const { transferProduct, canEditTransfers, isEditable, transferStore } = props

  const removeBatch = (index: number) => {
    transferProduct.removeBatch(index)

    const newProductQuantity = transferProduct.isBatchTracked
      ? transferProduct.sumBatchQuantity
      : transferProduct.quantity
    const newProductTotal = transferProduct.costPerUnit * (newProductQuantity || 0)
    transferProduct.setTotal(newProductTotal)
    transferProduct.setQuantity(transferProduct.sumBatchQuantity)
  }

  return (
    <table className='table table-sm'>
      <thead className='thead-light'>
        <tr>
          <th>Lot number</th>
          <th>Source stock</th>
          <th>Dest stock</th>
          <th>Transfer stock</th>
          {canEditTransfers && isEditable && <th className='deleteColumn'>Delete</th>}
        </tr>
      </thead>

      <tbody>
        {transferProduct.batches.map((batch, index) => {
          return (
            <tr key={index}>
              <td>{batch.batchNumber}</td>
              <td>{batch.fromLocationInventory}</td>
              <td>{batch.toLocationInventory}</td>
              <td>{batch.quantity}</td>
              {canEditTransfers && isEditable && (
                <td className='deleteColumn' style={{ cursor: 'pointer' }}>
                  <span
                    className='fa fa-trash-o delete-icon'
                    onClick={() => {
                      removeBatch(index)
                      transferStore.hasUnsavedChanges = true
                    }}
                  />
                </td>
              )}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
})
